import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { CustomTag } from 'app/typings/customTags';
import { apiMutation, apiRequest } from 'app/utils/request/api';

const path = '/tags' as const;

export function useCustomTags() {
  return useQuery({
    queryKey: [path],
    queryFn: () =>
      apiRequest({
        path,
        queryParams: { tagType: 'package_custom' },
      }) as Promise<CustomTag[]>,
    meta: { errorMessage: 'Error fetching CustomTags' },
    staleTime: Infinity,
  });
}

export function useCreateCustomTag() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: string) =>
      apiMutation('POST', { path }, { name: payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [path],
      });
    },
  });
}

type PayloadUpdateProps = {
  id: number;
  name: string;
};

export function useUpdateCustomTag() {
  const queryClient = useQueryClient();

  return useMutation<CustomTag, unknown, PayloadUpdateProps>({
    mutationFn: async ({ id, name }) =>
      apiMutation(
        'PUT',
        {
          path: `/tags/${id}`,
        },
        { name }
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [path],
      });
    },
  });
}
